import constants from 'constants/index'

const { EMPTY_CATEGORY_DESCRIPTION_ITEM } = constants.dai.disputes

const createCategoryDescriptionItem = () => ({
  ...EMPTY_CATEGORY_DESCRIPTION_ITEM,
})

export default createCategoryDescriptionItem
